import { render, staticRenderFns } from "./InternalLinks.pug?vue&type=template&id=343a6bd8&lang=pug&external"
import script from "./InternalLinks.js?vue&type=script&lang=js&external"
export * from "./InternalLinks.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports